import {
  forgotLockPin,
  ForgotLockPinMutation,
  graphqlCall,
} from '@akin-home/amplify';

interface Params {
  user_id: string;
}

export const submitForgotLockPIN = async (params: Params) => {
  const { user_id } = params;

  const res = await graphqlCall<ForgotLockPinMutation>(forgotLockPin, {
    user_id,
  });
  const data = res.data.forgotLockPIN;

  if (data) {
    return JSON.parse(data);
  }

  return { error: 'Something went wrong' };
};
